import { FC, useState } from "react";

import { Switch } from "antd";

import { CampaignAccessDataUser } from "../../store";
import { UserRole } from "../../../../auth/store";

interface UserCampaignAccessTogleProps {
  user: CampaignAccessDataUser;
  toggleUserAccess: (userUUID: string, value: boolean) => void;
}

export const UserCampaignAccessTogle: FC<UserCampaignAccessTogleProps> = ({
  user,
  toggleUserAccess,
}) => {
  const [userHasAccess, setUserHasAccess] = useState(
    user.hasAccessToCampaign || false
  );

  const userIsAdmin = user.role === UserRole.ADMIN;
  const userIsPendingInvitation = user.invitationPendingStatus;
  const disableToggle = userIsAdmin || userIsPendingInvitation;
  const adminToggleDisabledMessage =
    "Admins have access to all Campaigns by default";
  const userInvitedToggleDisabledMessage =
    "This user has not confirmed the invitation yet";
  const toggleDisabledMessage =
    userIsAdmin && !userIsPendingInvitation
      ? adminToggleDisabledMessage
      : userInvitedToggleDisabledMessage;

  // If user is still invitation-pending: Show in gray
  // If user does NOT have access: show in primary color
  // If user has access: show in green
  let backgroundColor = userIsPendingInvitation
    ? "gray"
    : "var(--primary-color)";

  if (userHasAccess) {
    backgroundColor = "var(--match-green)";
  }

  // Needed for Switch to display the proper value since it's inside a Table
  // And the data for the Table is not refreshed
  const handleToggle = (value: boolean) => {
    setUserHasAccess(value);
    toggleUserAccess(user.uuid, value);
  };

  return (
    <Switch
      title={disableToggle ? toggleDisabledMessage : ""}
      style={{
        backgroundColor: backgroundColor,
      }}
      checked={userHasAccess}
      onChange={handleToggle}
      disabled={disableToggle}
    />
  );
};
